module.exports = __webpack_public_path__ + "static/media/icon_instrument_cello.25fd55a1.svg";